
import React, { Component } from 'react';


import './LoadPastMessages.scss';


export interface LoadPastMessagesProps {
  isLoadingPastMessages:boolean;
  hasPastMessages:boolean;
  loadPastMessages():void;
}


export default class LoadPastMessages extends React.Component<LoadPastMessagesProps> {
  render() {
    var className = (this.props.isLoadingPastMessages) ? "scc-loadPastMessages scc-loading" : "scc-loadPastMessages";
    if (!this.props.hasPastMessages) { className += " scc-hidden"; }

    // return <div className={"scc-loadPastMessages"} >
    //                   <div className="scc-loadPastMessagesText scc-loadPastMessagesTextNotLoading swivl-loadPastMessages"  onClick={this.props.loadPastMessages}>Loading Past Messages</div>

    // </div>

    return <div className={className} >
              <div className="scc-loadPastMessagesWrapper">
                <div className="scc-loadPastMessagesSpinnerWrapper">
                  <svg className="scc-loadPastMessagesSpinner swivl-loadingPastMessagesSpinner" width="29" height="29" xmlns="http://www.w3.org/2000/svg">
                      <path d="M14.5 0C6.49 0 0 6.49 0 14.5S6.49 29 14.5 29 29 22.51 29 14.5 22.51 0 14.5 0zm7.473 14.53c0 4.109-3.364 7.473-7.473 7.473S7.027 18.64 7.027 14.53l.03-.358A7.398 7.398 0 0 1 9.23 9.23c.417-.417 1.161-.417 1.608 0a1.15 1.15 0 0 1 0 1.608c-1.4 1.4-1.876 3.424-1.25 5.33l.059.178A5.182 5.182 0 0 0 14.5 19.74a5.216 5.216 0 0 0 5.21-5.21c0-1.4-.535-2.68-1.488-3.662v1.19a1.13 1.13 0 1 1-2.263 0v-3.93a1.13 1.13 0 0 1 1.131-1.131h3.752a1.13 1.13 0 1 1 0 2.263H19.8a7.408 7.408 0 0 1 2.173 5.27z" fillRule="nonzero"></path>
                  </svg>
                </div>
                <div className="scc-loadPastMessagesText scc-loadPastMessagesTextNotLoading swivl-loadPastMessages" onClick={this.props.loadPastMessages}>Load Past Messages</div>
                <div className="scc-loadPastMessagesText scc-loadPastMessagesTextLoading swivl-loadingPastMessages">Loading Past Messages</div>

              </div>
            </div>
  }
}
